// 決済音カタログ (#959 / 管理番号_009・010)
//
// **運営が管理し、店舗は soundId で参照するだけ**（店舗にアップロード経路は無い）。
// Phase 1 は音源を frontend の静的アセット (public/sounds/*.mp3) に置く暫定運用。
// 将来は GCS + /admin/sounds に移すが、店舗が保存するのは soundId だけなので
// 移行しても選択は不変（#959 のコメント参照）。
//
// soundId を増やすときは public/sounds/ に mp3 を足し、ここに 1 行追加する。

export interface PaymentSoundPreset {
  /** 永続化される安定 id。owner doc の paymentSoundId が参照する。 */
  id: string
  /** 店舗設定プルダウンの表示名（ja）。 */
  labelJa: string
  /** 配信パス（public/ 配下 → ルート直下で配信）。 */
  src: string
}

export const PAYMENT_SOUND_PRESETS: PaymentSoundPreset[] = [
  { id: 'yokosopay-one', labelJa: 'YOKOSO PAY ①', src: '/sounds/yokosopay-one.mp3' },
  { id: 'yokosopay-two', labelJa: 'YOKOSO PAY ②', src: '/sounds/yokosopay-two.mp3' },
  { id: 'yokosopay-tree', labelJa: 'YOKOSO PAY ③', src: '/sounds/yokosopay-tree.mp3' },
]

/** "" / null / 未知の id は「オフ（鳴らさない）」扱い。 */
export function getPaymentSoundPreset(soundId: string | null | undefined): PaymentSoundPreset | null {
  if (!soundId) return null
  return PAYMENT_SOUND_PRESETS.find((p) => p.id === soundId) ?? null
}

/**
 * 選択中の決済音を再生（会計完了時に店舗側で呼ぶ）。best-effort で、未対応・
 * 自動再生ブロック時は握りつぶす（視覚表示が別途あるため）。soundId が "" /
 * null なら何もしない（= オフ）。
 */
export function playPaymentSound(soundId: string | null | undefined): void {
  const preset = getPaymentSoundPreset(soundId)
  if (!preset) return
  try {
    const audio = new Audio(preset.src)
    audio.play().catch(() => { /* autoplay policy / unsupported — ignore */ })
  } catch {
    // Audio unsupported — caller still has the visual cue.
  }
}
